import common from "./common";
import apps from "./apps";
import errors from "./errors";
import logs from "./logs";
import organizations from "./organizations";
import resellers from "./resellers";
import users from "./users";
import roles from "./roles";
import permissions from "./permissions";
import products from "./products";
import resellerInvoices from "./resellerInvoices";
import resellerPayments from "./resellerPayments";
import resellerProduct from "./resellerProduct";
import resellerServices from "./resellerServices";
import invoices from "./invoices";
import customers from "./customers";
import packages from "./packages";
import subscriptions from "./subscriptions";
import payments from "./payments";
import profile from "./profile";
import contacts from "./contacts";
import suppliers from "./suppliers";
import locations from "./locations";
import files from "./files";
import notifications from "./notifications";
import cafeterias from "./cafeterias";
import establishments from "./establishments";
import servicecenters from "./serviceCenters";
import purchasesOrders from "./purchasesOrders";
import purchasesInvoices from "./purchasesInvoices";
import purchasesDeliveries from "./purchasesDeliveries";
import purchasesPayments from "./purchasesPayments";
import salesOrders from "./salesOrders";
import salesInvoices from "./salesInvoices";
import salesDeliveries from "./salesDeliveries";
import salesPayments from "./salesPayments";
import warehouses from "./warehouses";
import stockMovements from "./stockMovements";
import imports from "./imports";
import supplyRules from "./supplyRules";
import categories from "./categories";
import taxes from "./taxes";
import taxGroups from "./taxGroups";
import options from "./options";
import paymentTerms from "./paymentTerms";
import events from "./events";
import cashRegisters from "./cashRegisters";
import cashRegisterReadings from "./cashRegisterReadings";
import cashRegisterReadingsReport from "./cashRegisterReadingsReport";
import weeklyReportsReport from "./weeklyReportsReport";
import posProductsReport from "./posProductsReport";
import cashRegisterReadingItems from "./cashRegisterReadingItems";
import cashRegisterReadingExpenseItems from "./cashRegisterReadingExpenseItems";
import cashRegisterReadingPaymentItems from "./cashRegisterReadingPaymentItems";
import cashRegisterReadingInvoiceItems from "./cashRegisterReadingInvoiceItems";
import equipments from "./equipments";
import categoryEquipments from "./categoryEquipments";
import validation from "./validation";
import weeklyReports from "./weeklyReports";
import establishmentTransfers from "./establishmentTransfers";
import equipmentTransfers from "./equipmentTransfers";
import establishmentInternalInvoices from "./establishmentInternalInvoices";
import establishmentInternalOrders from "./establishmentInternalOrders";
import internalDocuments from "./internalDocuments";
import specialOrderReservations from "./specialOrderReservations";
import trainings from "./trainings";

export default {
  COMMON: common,
  APPS: apps,
  ERRORS: errors,
  LOGS: logs,
  USERS: users,
  ORGANIZATIONS: organizations,
  RESELLERS: resellers,
  ROLES: roles,
  PERMISSIONS: permissions,
  PRODUCTS: products,
  INVOICES: invoices,
  CUSTOMERS: customers,
  SUBSCRIPTIONS: subscriptions,
  PACKAGES: packages,
  PAYMENTS: payments,
  PROFILE: profile,
  CONTACTS: contacts,
  SUPPLIERS: suppliers,
  LOCATIONS: locations,
  FILES: files,
  NOTIFICATIONS: notifications,
  CAFETERIAS: cafeterias,
  ESTABLISHMENTS: establishments,
  SERVICECENTERS: servicecenters,
  PURCHASES_ORDERS: purchasesOrders,
  PURCHASES_INVOICES: purchasesInvoices,
  PURCHASES_DELIVERIES: purchasesDeliveries,
  PURCHASES_PAYMENTS: purchasesPayments,
  SALES_ORDERS: salesOrders,
  SALES_INVOICES: salesInvoices,
  SALES_DELIVERIES: salesDeliveries,
  SALES_PAYMENTS: salesPayments,
  RESELLER_PRODUCTS: resellerProduct,
  RESELLER_SERVICES: resellerServices,
  RESELLER_INVOICES: resellerInvoices,
  RESELLER_PAYMENTS: resellerPayments,
  WAREHOUSES: warehouses,
  SUPPLY_RULES: supplyRules,
  STOCK_MOVEMENTS: stockMovements,
  IMPORTS: imports,
  CATEGORIES: categories,
  TAXES: taxes,
  TAX_GROUPS: taxGroups,
  OPTIONS: options,
  PAYMENT_TERMS: paymentTerms,
  EVENTS: events,
  CASH_REGISTERS: cashRegisters,
  CASH_REGISTER_READINGS: cashRegisterReadings,
  CASH_REGISTER_READINGS_REPORT: cashRegisterReadingsReport,
  WEEKLY_REPORTS_REPORT: weeklyReportsReport,
  POS_PRODUCTS_REPORT: posProductsReport,
  CASH_REGISTER_READING_ITEMS: cashRegisterReadingItems,
  CASH_REGISTER_READING_EXPENSE_ITEMS: cashRegisterReadingExpenseItems,
  CASH_REGISTER_READING_PAYMENT_ITEMS: cashRegisterReadingPaymentItems,
  CASH_REGISTER_READING_INVOICE_ITEMS: cashRegisterReadingInvoiceItems,
  CATEGORY_EQUIPMENTS: categoryEquipments,
  EQUIPMENTS: equipments,
  VALIDATION: validation,
  WEEKLY_REPORTS: weeklyReports,
  ESTABLISHMENT_TRANSFERS: establishmentTransfers,
  EQUIPMENT_TRANSFERS: equipmentTransfers,
  ESTABLISHMENT_INTERNAL_INVOICES: establishmentInternalInvoices,
  ESTABLISHMENT_INTERNAL_ORDERS: establishmentInternalOrders,
  INTERNAL_DOCUMENTS: internalDocuments,
  SPECIAL_ORDER_RESERVATIONS: specialOrderReservations,
  TRAININGS: trainings,
};
